import { Box, Typography } from "@material-ui/core";
import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import { useObserver } from "mobx-react-lite";
import { TypographyVariants } from "Custom/StylesAppSpecific/TypographyVariants";
import UserAccessViewModel from "Custom/ViewModels/UserAccessViewModel";
import { BudgetQuoteBox } from "./BudgetQuoteBox";
import { ErrorBox } from "./ErrorBox";
import { BQSButton } from "../Primitives/Buttons/BQSButton";
import { BQSEdit } from "Custom/Views/Primitives/Edits/BQSEdit";
import { BQSCheckBox } from "Custom/Views/Primitives/CheckBoxes/BQSCheckBox";
import { ValidationError } from "class-validator";
import { Stores, StoresContext } from "Custom/Stores";

export const UserPageDetails: React.FunctionComponent = () => {
    const storesContext = useContext<Stores>(StoresContext);
    const typopgraphyClasses = TypographyVariants();
    const [viewModel] = useState(() => new UserAccessViewModel());

    const submit = () => {
        viewModel.Store();
    };

    /*     useLayoutEffect(() => {
        alert(storesContext.domain.AccountStore.hasUserAccess);
    }, [storesContext.domain.AccountStore.hasUserAccess]); */

    useEffect(() => {
        /*         let count = viewModel.model.Errors.length;
        setErrorCount(viewModel.model.Errors.length); */
    }, [viewModel.model.Errors]);

    return useObserver(() => (
        <BudgetQuoteBox>
            <Box className="form-wrapper">
                <Box>
                    <Typography variant="h3" className={typopgraphyClasses.gform_title}>
                        Access the budget quote
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="caption" className={typopgraphyClasses.gform_description}>
                        To access the budget quote please complete the following details.
                    </Typography>
                </Box>

                {viewModel.isInerror && <ErrorBox>There was a problem with your submission. Errors have been highlighted below.</ErrorBox>}
                <Box className={viewModel.isInErrorClass("displayName")}>
                    <BQSEdit
                        key="name"
                        className=""
                        displayName="Name *"
                        value={viewModel.model.displayName}
                        execute={viewModel.setDisplayName}
                        validationMessage={viewModel.displayNameError}
                    />
                </Box>
                <Box className={viewModel.isInErrorClass("email")}>
                    <BQSEdit
                        key="email"
                        className=""
                        displayName="Email Address *"
                        value={viewModel.model.email}
                        execute={viewModel.setEmail}
                        validationMessage={viewModel.emailError}
                    />
                </Box>
                <Box className={viewModel.isInErrorClass("telephone")}>
                    <BQSEdit
                        key="telephone"
                        className=""
                        displayName="Telephone *"
                        value={viewModel.model.telephone}
                        execute={viewModel.setTelephone}
                        validationMessage={viewModel.telephoneError}
                    />
                </Box>
                <Box className={viewModel.isInErrorClass("company")}>
                    <BQSEdit
                        key="company"
                        className=""
                        displayName=" Company *"
                        value={viewModel.model.company}
                        execute={viewModel.setCompany}
                        validationMessage={viewModel.companyError}
                    />
                </Box>
                <Box className="user-consent">
                    <Box className="marketingconsenttext">
                        <Typography className={typopgraphyClasses.gfield_description}>
                            By submitting this form you consent to us storing your data for the sole purpose of providing you with a quotation.
                        </Typography>
                    </Box>
                </Box>
                {/*  <Box>
                    <Typography variant="caption" className={typopgraphyClasses.gfield_label}>
                        We need you to say YES
                    </Typography>
                </Box>
                <Box className="user-consent">
                    <Box className="marketingconsenttext">
                        <Typography className={typopgraphyClasses.gfield_description}>
                            From time to time we may want to send you marketing emails about new training courses we are offering, new CPDs, new products or services, changes to
                            products and services. We will always treat your permission details with the utmost confidentiality and never sell them to other companies for marketing
                            purposes.
                        </Typography>
                    </Box>
                    <Box className="marketingconsenticon"></Box>
                </Box>
                <Box>
                    <Typography variant="caption" className={typopgraphyClasses.gfield_description}>
                        <b>To allow us to do this please tick yes.</b>
                    </Typography>
                </Box>
                <BQSCheckBox displayName="Yes" isSelected={viewModel.model.allowMarketing} execute={viewModel.setAllowMarketing} /> */}
                <Box className="submitRow">
                    <BQSButton
                        displayName="Submit"
                        execute={() => {
                            submit();
                        }}
                    />
                </Box>
            </Box>
        </BudgetQuoteBox>
    ));
};
